// @flow
import styled from 'styled-components';
import { below } from "../../assets/css/media";
import colors from "../../assets/css/colors";

export const ModalInnerTitle = styled.h2`
	text-align: center;
	margin: 1.35em auto .9em;
	font-size: 28px;
	font-weight: bold;
	line-height: 1.2;
	color: ${colors.nrlDarkGreen};
	max-width: 80%;

	${below.tablet`
		font-size: 22px;
	`}
`;

export default ModalInnerTitle;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalInnerTitle.js